module.exports = __webpack_public_path__ + "static/media/copy-icon.5146d2ac.svg";